var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpgradeSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15-Upgrade-successful",
    transform: "translate(-414.000000, -11.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(414.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25,3.74925 C10.04625,4.2975 11.4525,5.7045 11.99925,7.5 C12.549,5.70375 13.95525,4.29825 15.75,3.75 C13.95525,3.20175 12.549,1.79625 11.99925,0 C11.4525,1.7955 10.04625,3.201 8.25,3.74925 Z M13.5,8.99925 C14.57775,9.32775 15.4215,10.17225 15.74925,11.25 C16.07925,10.17225 16.923,9.3285 18,9 C16.923,8.67075 16.07925,7.82775 15.74925,6.75 C15.4215,7.827 14.57775,8.67075 13.5,8.99925 L13.5,8.99925 Z M9,13.125 C9.8985,13.39875 10.60125,14.10225 10.87425,15 C11.14875,14.1015 11.85225,13.39875 12.75,13.125 C11.85225,12.8505 11.1495,12.1485 10.87425,11.25 C10.60125,12.14775 9.8985,12.8505 9,13.125 Z M4.5,6.921 C4.8915,7.4145 5.3385,7.86075 5.83125,8.25225 C5.3385,8.64375 4.89225,9.09 4.5015,9.58275 C4.11,9.08925 3.663,8.643 3.1695,8.25075 C3.663,7.86 4.1085,7.41375 4.5,6.921 L4.5,6.921 Z M4.49925,3.75 C3.843,5.90475 2.15325,7.59375 0,8.25075 C2.157,8.91075 3.843,10.59675 4.503,12.75375 C5.15925,10.59825 6.849,8.91075 9,8.25075 C6.849,7.59525 5.15925,5.9055 4.49925,3.75 Z",
    id: "icon-upgrade-success"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgradeSuccess);
export default __webpack_public_path__ + "static/media/icon-upgrade-success.8a0cb48e8e0d7f63f90471f85d9fbeba.svg";
export { ForwardRef as ReactComponent };